<template>
  <div>
    <h1 class="text-center">{{ offers.title }}</h1>
    <div class="d-flex justify-space-around flex-wrap">
      <OneOffer v-for="one in offers.list" :key="one.Title" :one="one"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OneOffer from './OneOffer.vue'

export default {
  components: { OneOffer },
  computed: {
    ...mapGetters('strapiv2', ['offers'])
  }
}
</script>
